module.exports = __webpack_public_path__ + "static/media/inf_39og48.a6278e3a.mp3";